"use client";

import { Marquee } from "@/components/marquee";
import { useEffect, useState } from "react";

export const SlideImage = () => {
  const [isLarge, setIsLarge] = useState<boolean>(false);
  const [isMedium, setIsMedium] = useState<boolean>(false);
  const images = [...Array(6)].map(
    (_, idx) => `/about/image_klinik-${idx + 1}.webp`
  );
  const imagesOne = images.slice(0, 3);
  const imagesTwo = images.slice(3, 6);

  useEffect(() => {
    const handleResize = () => {
      setIsMedium(window.innerWidth < 1024);
      setIsLarge(window.innerWidth < 1280);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative w-full h-full flex flex-col lg:flex-row gap-4 z-0">
      <Marquee
        images={imagesOne}
        width={isLarge ? 160 : 272}
        height={isLarge ? 200 : 340}
        direction={isMedium ? "horizontal" : "vertical"}
        speed={30}
        imageMult={4}
        gap={isMedium ? 12 : 20}
      />
      <Marquee
        images={imagesTwo}
        width={isLarge ? 160 : 272}
        height={isLarge ? 200 : 340}
        direction={isMedium ? "horizontal" : "vertical"}
        reversed={true}
        speed={30}
        imageMult={4}
        gap={isMedium ? 12 : 20}
      />
    </div>
  );
};
